<template>
  <FormulateForm @submit="(data) => $emit('submit', data)">
    <!-- @slot Content of the form. -->
    <slot />
  </FormulateForm>
</template>

<script>
export default {
  name: 'FormWrapper',
  methods: {
    submit(data) {
      /**
       * This is only triggered if everything passes validation.
       * @event submit
       */
      this.$emit('submit', data)
    }
  }
}
</script>

<style></style>
